import { useBudgetWarning } from '@/contexts/BudgetWarningContext'

export default function BudgetBanner() {
  const { showWarning } = useBudgetWarning()

  if (!showWarning) {
    return null
  }

  return (
    <div className="border-b border-amber-200 bg-amber-50 px-4 py-2 text-sm text-amber-900">
      This tool is approaching its monthly budget
    </div>
  )
}
